module.exports = __webpack_public_path__ + "static/media/frustration.ec9dba9e.svg";